<!-- card 6 -->
<div
  class="w-full rounded border border-[#e0e6ed] bg-white p-5 shadow-[4px_6px_10px_-3px_#bfc9d4] dark:border-[#1b2e4b] dark:bg-[#191e3a] dark:shadow-none"
>
  <div class="text-[#515365] dark:text-white-light">
    <form class="space-y-5" [formGroup]="form">


      <div>
        <label>Category :</label>
        <ng-select
          [items]="categories"
          bindLabel="label"
          bindValue="value"
          [clearable]="true"
          placeholder="Select Category"
          class="custom-multiselect w-full"
          formControlName="category_code"
        >
        </ng-select>
        <form-error
          [form]="form"
          controlName="category_code"
          [validations]="MasterProductFormValidations.category_code"></form-error>
      </div>


      <div>
        <label>Provider:</label>
        <ng-select
          [items]="providers"
          bindLabel="label"
          bindValue="value"
          [clearable]="true"
          placeholder="Select Provider Code"
          class="custom-multiselect w-full"
          formControlName="provider_code"
        >
        </ng-select>
        <form-error
          [form]="form"
          controlName="provider_code"
          [validations]="MasterProductFormValidations.provider_code"></form-error>
      </div>

      <div>
        <label for="name">Product Name:</label>
        <input id="name" type="text" placeholder="Enter Product Name" class="form-input" formControlName="name" />
        <form-error [form]="form" controlName="name" [validations]="MasterProductFormValidations.name"></form-error>
      </div>

      <div>
        <label for="brand">Brand:</label>
        <input id="brand" type="text" placeholder="Enter Brand" class="form-input" formControlName="brand" />
        <form-error [form]="form" controlName="brand" [validations]="MasterProductFormValidations.brand"></form-error>
      </div>

      <div>
        <label for="price">Price:</label>
        <input id="price" type="number" placeholder="Enter Price" class="form-input" formControlName="price" />
        <form-error [form]="form" controlName="price" [validations]="MasterProductFormValidations.price"></form-error>
      </div>

      <div>
        <label for="sellingPrice">Selling Price:</label>
        <input id="sellingPrice" type="number" placeholder="Enter Selling Price" class="form-input" formControlName="selling_price" />
        <form-error [form]="form" controlName="selling_price" [validations]="MasterProductFormValidations.price"></form-error>
      </div>

      <div>
        <label for="code">Product Code:</label>
        <input id="code" type="text" placeholder="Enter Product Code" class="form-input"
               formControlName="code" />
        <form-error [form]="form" controlName="code"
                    [validations]="MasterProductFormValidations.code"></form-error>
      </div>


      <div>
        <label for="provider_product">Provider Product:</label>
        <input id="provider_product" type="text" placeholder="Enter Provider Product" class="form-input"
               formControlName="provider_product" />
        <form-error [form]="form" controlName="provider_product"
                    [validations]="MasterProductFormValidations.provider_product"></form-error>
      </div>

      <div>
        <label for="admin_fee">Admin Fee:</label>
        <input id="admin_fee" type="number" placeholder="Enter Admin Fee" class="form-input"
               formControlName="admin_fee" />
        <form-error [form]="form" controlName="admin_fee"
                    [validations]="MasterProductFormValidations.admin_fee"></form-error>
      </div>

      <div>
        <label>Status:</label>
        <ng-select
          [items]="activeStatus"
          [clearable]="true"
          placeholder="Select Status"
          class="custom-multiselect w-full"
          formControlName="active"
          bindLabel="label"
          bindValue="value"
        >
        </ng-select>
      </div>

      <button
        [disabled]="form.invalid"
        type="button"
        class="btn btn-success mt-4 w-full md:w-[180px]"
        (click)="saveData()"
      >
        <span
          *ngIf="loading"
          class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"
        ></span>
        Submit
      </button>
    </form>
  </div>
</div>
